import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {StoreServiceDeliveryTimeFrameValueFormFieldProps} from "../types";
import {FormField, FormFieldError} from "../../../../../design-system/form-field";
import {StoreServiceDeliveryTimeFrameFormFields} from "../types";

export function ServiceDeliveryTimeFrameValueFormField({
  id,
  label,
  placeholder,
}: StoreServiceDeliveryTimeFrameValueFormFieldProps) {
  const {control} = useFormContext<StoreServiceDeliveryTimeFrameFormFields>();

  return (
    <div>
      <FormField
        id={id}
        label={label}
        // label="Call duration (In minutes)"
        renderInput={(id) => (
          <Controller
            control={control}
            name="deliveryTimeFrameValue"
            render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
              <Space direction="vertical" size={16} style={{display: "flex"}}>
                <Input
                  id={id}
                  status={error?.message ? "error" : ""}
                  onChange={onChange}
                  onBlur={onBlur}
                  size="large"
                  value={value}
                  placeholder={placeholder}
                  ref={ref}
                />
                <FormFieldError errorMessage={error?.message} />
              </Space>
            )}
          />
        )}
      />
    </div>
  );
}
